import { render, staticRenderFns } from "./Geländer.vue?vue&type=template&id=62c4073f&"
import script from "./Geländer.vue?vue&type=script&lang=js&"
export * from "./Geländer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports